import { isEmpty } from 'lodash-es'
import { useAppSelector } from 'store'

const useAuthenticate = () => {
  const authExpired = useAppSelector((state) => state.auth.authExpired)
  const token = useAppSelector((state) => state.auth.token)
  const selectedBranch = useAppSelector((state) => state.user.selectedBranch)
  const userId = useAppSelector((state) => state.user.user?.id)

  // User is considered authenticated when:
  //  a. user id is available
  //  b. token is available and not expired
  const isAuthenticated = !authExpired.isTokenExpired && !isEmpty(token) && !!userId
  return {
    isAuthenticated,
    isSelectedBranch: !!selectedBranch,
  }
}

export default useAuthenticate
